import React from "react";
import { aboutFeatures } from "../mock";
import { ShieldCheck, MapPin, PoundSterling, ArrowRight } from "lucide-react";
import { Button } from "../components/ui/button";

const iconMap = { ShieldCheck, MapPin, PoundSterling };

const About = () => {
  const aboutImg = "https://images.pexels.com/photos/13871294/pexels-photo-13871294.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Image */}
          <div className="relative">
            <div className="overflow-hidden rounded-lg shadow-2xl relative">
              <img
                src={aboutImg}
                alt="Beautiful landscaped garden"
                className="w-full h-[520px] object-cover hover:scale-105 transition-transform duration-700"
              />
            </div>
            {/* Experience badge */}
            <div className="absolute -bottom-6 -right-6 sm:right-6 bg-brand-yellow px-8 py-6 rounded-md shadow-xl">
              <div className="font-display text-4xl md:text-5xl text-brand-dark leading-none">
                10<span className="text-3xl">+</span>
              </div>
              <div className="text-brand-dark text-[10px] font-bold tracking-[0.2em] mt-1">
                YEARS EXPERIENCE
              </div>
            </div>
          </div>

          {/* Content */}
          <div>
            <div className="text-brand-yellow text-sm font-bold tracking-[0.3em] mb-4">
              ABOUT KJ GROUND FORCE
            </div>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl text-brand-dark leading-[1.05] mb-6">
              BUILT ON EXPERIENCE. FOCUSED ON QUALITY.
            </h2>
            <p className="text-gray-600 text-base md:text-lg leading-relaxed mb-8">
              With years of hands-on experience, KJ Ground Force provides a
              complete range of groundwork and landscaping services. From start
              to finish, we're committed to delivering exceptional results and
              customer satisfaction.
            </p>

            <div className="space-y-4 mb-10">
              {aboutFeatures.map((f) => {
                const Icon = iconMap[f.icon];
                return (
                  <div key={f.id} className="flex items-start gap-4">
                    <div className="w-11 h-11 bg-brand-dark rounded-md flex items-center justify-center shrink-0">
                      {Icon && <Icon className="text-brand-yellow" size={20} />}
                    </div>
                    <div>
                      <h4 className="font-display text-base text-brand-dark tracking-wide mb-0.5">
                        {f.title}
                      </h4>
                      <p className="text-gray-600 text-sm">{f.description}</p>
                    </div>
                  </div>
                );
              })}
            </div>

            <Button
              variant="outline"
              className="border-2 border-brand-dark bg-transparent hover:bg-brand-dark hover:text-white text-brand-dark font-bold tracking-wider text-sm px-8 py-7 rounded-md group"
            >
              READ MORE
              <ArrowRight size={16} className="ml-2 group-hover:translate-x-1 transition-transform" />
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
